import Images500500Svg from '@/public/images/500/500.svg';
import Images500WhiskyBrokenWebp from '@/public/images/500/whiskyBroken.webp';

export { Images500500Svg, Images500WhiskyBrokenWebp };
